export const SET_APPLIED = "DIMENSION_TOOL_PANEL/APPLIED/SET";
export const APPLY = "DIMENSION_TOOL_PANEL/APPLIED/APPLY";
